import type { SidebarNavSection } from './customerAreaLayoutTypes'
import { joinClassNames, SidebarNavIcon } from './customerAreaNavShared'

type CustomerAreaDesktopNavigationProps = {
  sections: SidebarNavSection[]
  activeNavId: string
  onNavigate: (targetPath: string) => void
}

export const CustomerAreaDesktopNavigation = ({
  sections,
  activeNavId,
  onNavigate,
}: CustomerAreaDesktopNavigationProps) => (
  <aside className="hidden lg:block">
    <nav className="ca-card-shell ca-theme-transition sticky top-4 p-2">
      <ul className="space-y-4">
        {sections.map((section) => (
          <li key={section.id}>
            <p className="px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-(--color-text-muted)">
              {section.label}
            </p>
            <ul className="mt-1 space-y-1">
              {section.items.map((item) => {
                const active = item.id === activeNavId
                return (
                  <li key={item.id}>
                    <button
                      type="button"
                      aria-current={active ? 'page' : undefined}
                      onClick={() => onNavigate(item.href)}
                      className={joinClassNames(
                        'ca-theme-transition group relative flex w-full items-start justify-between gap-2 rounded-[10px] border px-2.5 py-2 text-left',
                        active
                          ? 'border-(--color-border-default) bg-(--color-bg-surface-muted) text-(--color-text-primary) shadow-(--shadow-sm)'
                          : 'border-transparent text-(--color-text-secondary) hover:border-(--color-border-default) hover:bg-(--color-bg-surface-muted) hover:text-(--color-text-primary)',
                      )}
                    >
                      <span
                        className={joinClassNames(
                          'absolute top-2 bottom-2 left-0.5 w-0.5 rounded-full transition-opacity duration-200',
                          active ? 'bg-(--color-action-primary) opacity-100' : 'opacity-0',
                        )}
                        aria-hidden
                      />
                      <span className="min-w-0 pl-1">
                        <span className="flex items-center gap-2">
                          <SidebarNavIcon itemId={item.id} active={active} />
                          <span className="block text-sm font-semibold">{item.label}</span>
                        </span>
                        {item.description ? (
                          <span
                            className={joinClassNames(
                              'mt-0.5 block text-[11px]',
                              active ? 'text-(--color-text-secondary)' : 'text-(--color-text-muted)',
                            )}
                          >
                            {item.description}
                          </span>
                        ) : null}
                      </span>
                      {item.badge ? (
                        <span
                          className={joinClassNames(
                            'rounded-full px-2 py-0.5 text-[11px] font-semibold',
                            active
                              ? 'bg-(--color-action-primary) text-(--color-action-primary-foreground)'
                              : 'bg-(--color-bg-surface-muted) text-(--color-text-secondary)',
                          )}
                        >
                          {item.badge}
                        </span>
                      ) : null}
                    </button>
                  </li>
                )
              })}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  </aside>
)
